module.exports = __webpack_public_path__ + "img/arousalEmotionGrid1.28318267.png";